import styled from '@emotion/styled';
import {
  Audio,
  AuthContainer,
  List,
  Logo,
  StyledDiv,
  Typography,
} from '@taleemabad/dsm/components';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';

interface RoleSelectionScreenProps {
  roles: Roles[];
  logo: string;
  onRoleSelected: (data: Roles[]) => void;
}
export interface Roles {
  id: number;
  name: string;
}
export const RoleSelectionScreen = ({
  logo,
  roles,
  onRoleSelected,
}: RoleSelectionScreenProps) => {
  return (
    <AuthContainer>
      <StyledImageWrapper>
        <Logo
          altName="outer-layer"
          width={275}
          src={`../../assets/${logo}`}
          data-cy="sign-in-app-logo"
        />
      </StyledImageWrapper>

      <StyledDiv flexDirection="column" marginBottom={42}>
        <Typography
          variant="textHeadlineLargeSurface"
          data-cy="sign-in-get-started"
        >
          Please Select your Role
        </Typography>
        <StyledDiv
          flexDirection="column"
          justifyContent="center"
          alignItem="flex-start"
          width="100%"
          marginBottom={12}
          marginTop={12}
        >
          <Audio
            isPlaying={true}
            src={
              'https://ai-textract-bucket.s3.ap-south-1.amazonaws.com/audio-files/Enter+phone+number.mp3'
            }
          />
        </StyledDiv>
        {roles.map((role, index) => (
          <List
            divider={roles.length - 1 !== index}
            alignment="center"
            key={role.id}
            onClick={() => onRoleSelected([role])}
            data-cy={`role-button-${role.id}`}
            heading={role.name}
            listContainerStyle="transparent"
            trailingIcon={{
              type: 'radio',
              name: role.name,
              checked: false,
              direction: 'trailing',
            }}
          />
        ))}
      </StyledDiv>
    </AuthContainer>
  );
};

const StyledImageWrapper = styled.div`
  display: none;
  align-items: center;
  justify-content: center;
  margin-bottom: 68px;
  ${mq(BreakpointSizes.xs)} {
    display: flex;
  }
`;
